import React from 'react';
import { renderSimpleMarkdownNodes } from '../utils/simpleMarkdown';
import './MarkdownText.css';

function MarkdownText({ text, className = '' }) {
  return (
    <span className={`markdown-text ${className}`.trim()}>
      {renderSimpleMarkdownNodes(text)}
    </span>
  );
}

export default MarkdownText;
